import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, EMPTY} from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';

import * as d3 from 'd3';

/*import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
*/
import {mUserUsage, Project, School, Year, Grade, Class, Subject, SchoolCategory, Country, Region, User, Role} from '../model/userUsage.model';


import { environment } from '../../environments/environment';
import { stringify } from '@angular/compiler/src/util';
import { CompileShallowModuleMetadata } from '@angular/compiler';
import { Subscription } from 'rxjs';

@Injectable()
export class userUsageDataService {

  headers: any;
  options: any;

  private date$Filter = new BehaviorSubject<any>({
    startDate: '2019-08-20T00:00:00Z',
    endDate: '2019-08-21T00:00:00Z'
  });
  currentDateFilter = this.date$Filter.asObservable();

  private other$Filter = new BehaviorSubject<any>({});
  currentOtherFilters = this.other$Filter.asObservable();

  // usage data
  private rawUserUsage$Data = new BehaviorSubject<mUserUsage[]>([]);
  readonly userUsage$Data = this.rawUserUsage$Data.asObservable();

  // section 1 User Activity Overview
  private rawLoginActivity$Data = new BehaviorSubject<any[]>([]);
  readonly loginActivity$Data = this.rawLoginActivity$Data.asObservable();
  private rawLoginActivityPer$Data = new BehaviorSubject<any[]>([]);
  readonly loginActivityPer$Data = this.rawLoginActivityPer$Data.asObservable();

  // section 2 User activity Trend
  private rawUserTrend$Data = new BehaviorSubject<any[]>([]);
  readonly userTrend$Data = this.rawUserTrend$Data.asObservable();

  // section 3 Total Users
  private rawTotalUsers$Data = new BehaviorSubject<any[]>([]);
  readonly totalUsers$Data = this.rawTotalUsers$Data.asObservable();
  private rawTotalUsersPer$Data = new BehaviorSubject<any[]>([]);
  readonly totalUsersPer$Data = this.rawTotalUsersPer$Data.asObservable();

  // section 4 New Users
  private rawNewUsers$Data = new BehaviorSubject<any[]>([]);
  readonly newUsers$Data = this.rawNewUsers$Data.asObservable();
  private rawNewUsersPer$Data = new BehaviorSubject<any[]>([]);
  readonly newUsersPer$Data = this.rawNewUsersPer$Data.asObservable();

  //
  // role list
  private rawUserType$Data = new BehaviorSubject<any[]>([]);
  readonly userType$Data = this.rawUserType$Data.asObservable();

  // gender list
  private rawGenderList$Data = new BehaviorSubject<any[]>([]);
  readonly genderList$Data = this.rawGenderList$Data.asObservable();
  private dateFilter:Subscription;
  constructor( private http: HttpClient) {
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.headers = headersItem;
  }

  setDateFilter(start, end?) {

    if (start) {
      //console.log('date filter - start ' + start);
      //console.log('date filter - end ' + end);
      if (start && end) {
        this.date$Filter.next(Object.assign({}, {
          startDate: start + 'T00:00:00Z',
          endDate: end + 'T23:59:59'
        }));
      } else {
        let startDate: string;
        let endDate: string;
        const curDate = new Date();
        endDate = curDate.getFullYear() + '-' + ('0' + (curDate.getMonth() + 1)).slice(-2) + '-' + ('0' + curDate.getDate()).slice(-2) + 'T23:59:59Z';

        let diffInHours = 0;
        if (start === '24Hours') {
          diffInHours = 24 * 3600;
        } else if (start === '7Days') {
          diffInHours = 7 * (24 * 3600);
        } else if (start === '30Days') {
          diffInHours = 30 * (24 * 3600);
        } else if (start === '90Days') {
          diffInHours = 90 * (24 * 3600);
        } else if (start === 'Year') {
          diffInHours = 365 * (24 * 3600);
        }

        const tmpDate = new Date(curDate.getTime() - (diffInHours * 1000));
        startDate = tmpDate.getFullYear() + '-' + ('0' + (tmpDate.getMonth() + 1)).slice(-2) + '-' + ('0' + tmpDate.getDate()).slice(-2) + 'T00:00:00Z';

        this.date$Filter.next(Object.assign({}, {
          startDate,
          endDate
        }));
      }
    }
  }

  setOtherFilter(filter: any) {
    if (filter) {
     // //console.log('other filters >>> ' + JSON.stringify(filter));
      this.other$Filter.next(Object.assign({}, filter));
    } else {
      this.other$Filter.next(Object.assign({}, EMPTY));
    }
  }

  // Get UserUsageData from server | HTTP GET
  loadUserUsageData() {
    console.log("loadUserUsageData>>>>>>")
    // toto: add all data filter
    let iscurrentDateFiltered:boolean = false;
    let count=0;
    if(this.dateFilter){
      this.dateFilter.unsubscribe();
    }
    this.dateFilter = this.currentDateFilter.subscribe( data => {
      const startDate = data.startDate;
      const endDate = data.endDate;
      let URLSearchParams = new HttpParams();

      URLSearchParams = URLSearchParams.set('startDate', startDate);
      URLSearchParams = URLSearchParams.set('endDate', endDate);
      iscurrentDateFiltered = true;
      this.options = { headers: this.headers, params: URLSearchParams };
      count = count+1;
      console.log("iscurrentDateFiltered>>>>>> "+count);
     
     // if(count==1){
      this.http.get(environment.dashAPI + '/users', this.options).subscribe(data1 => {
         // console.log('response data >>> '+ JSON.stringify(data1));
          iscurrentDateFiltered = false;         
          try {
            this.rawUserUsage$Data.next(Object.assign([], data1));
            console.log("iscurrentDateFiltered inside>>>>>> "+iscurrentDateFiltered);
          } catch (err) {
            this.rawUserUsage$Data.next(null);
            this.clearUserCache();
          }
        }, error => {
          // //console.log('Could not load todos.')
          this.rawUserUsage$Data.next(null);
          this.clearUserCache();
        });
      //}
    });

  }

  // Clear configs
  clearUserCache() {
    this.rawUserUsage$Data.next(Object.assign([], EMPTY));
    this.rawLoginActivity$Data.next(Object.assign([], EMPTY));
    this.rawLoginActivityPer$Data.next(Object.assign([], EMPTY));
    this.rawUserTrend$Data.next(Object.assign([], EMPTY));
    this.rawTotalUsers$Data.next(Object.assign([], EMPTY));
    this.rawTotalUsers$Data.next(Object.assign([], EMPTY));
    this.rawTotalUsersPer$Data.next(Object.assign([], EMPTY));
    this.rawNewUsers$Data.next(Object.assign([], EMPTY));
    this.rawNewUsersPer$Data.next(Object.assign([], EMPTY));
  }

  // overview tab and user tab user activity overview chart data
  getUserActivityOverviewData() {    
    const filter = {};
    
    this.userUsage$Data.subscribe( data => {
    ////console.log('data janaaaanakiikikikkkkkkkk ########### ' + JSON.stringify(data));
      if (data && data.length > 0) {
        let filterredData:any[] = data;
        this.currentOtherFilters.subscribe( filter => {
          //
          // const filter = data;
          // //console.log(' activity other filter >> ' + JSON.stringify(filter));

          if (filter) {
            // //console.log(data);
            // //console.log(filter);
            filterredData = data.filter(function(item){
              
               for (let key in filter) {
               //  //console.log('filter key value ----' + filter[key]+' : '+key);
               // //console.log('item key value ---' + JSON.stringify(item[key]));
                if(key!='role'){
                  if (item[key] === undefined || item[key] != filter[key]) {                 
                    return false;
                  }         
                }else{
                  ////console.log('Role is being filtered');
                  if(JSON.stringify(item.role) !== JSON.stringify(filter.role) ){
                    return false;
                  }
                }
              } 
              
              return true;
            });
             ////console.log(' activity filtered data >> ' + JSON.stringify(filterredData));
          }
        // });

          if (filterredData && filterredData.length > 0) {
          const tmpData = d3.nest<mUserUsage, number>()
            .key(function(d: any) { 
             // //console.log('keyyyyy Janaki >>> '+JSON.stringify(d))
              return d.role.name; 
            })
            .rollup(function(v) {
              return d3.sum(v, function(g: any) { return parseInt(g.no_of_logins); });
            })
            .entries(filterredData);
          let i;
          const result: any = [];
          // //console.log('tmpData >>>> '+JSON.stringify(tmpData));
          for (i = 0; i < tmpData.length; i++){
              result[i] = {};
              result[i].id = tmpData[i].key;
              result[i].count = tmpData[i].value;
          }
          this.rawLoginActivity$Data.next(Object.assign([], result));
        } else {
          // //console.log('filterred data empty >>> ' + JSON.stringify(filterredData));
          this.rawLoginActivity$Data.next(Object.assign([], EMPTY));
        }
      });
      } else {
        this.rawLoginActivity$Data.next(Object.assign([], EMPTY));
      }
    }); 
  }


  // overview tab and user tab
  getUserActivityOverviewPerData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    this.userUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let filterredData: any[] = data;
        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (let key in filter) {
                if(key!='role'){
                  if (item[key] === undefined || item[key] != filter[key]) {                 
                    return false;
                  }         
                }else{
                  ////console.log('Role is being filtered');
                  if(JSON.stringify(item.role) !== JSON.stringify(filter.role) ){
                    return false;
                  }
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .key(function(d: any) { return d.device_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_logins); });
              })
              .entries(filterredData);
            // //console.log('Per tmpData >>> ' + JSON.stringify(tmpData));
            let i;
            const result: any[] = [];
            for (i = 0; i < tmpData.length; i++){
                result[i] = {};
                result[i].role = tmpData[i].key;
                // tmpData[i].count = tmpData[i]['value'];
                delete tmpData[i].key;
                // delete tmpData[i].value;
                if (tmpData[i].values) {
                  result[i].total = d3.sum(tmpData[i].values, function(g: any) {return parseInt(g.value); });
                  let j = 0;
                  for (j = 0; j < tmpData[i].values.length; j ++) {
                    result[i][tmpData[i].values[j].key] = Math.ceil((tmpData[i].values[j].value * 100) / result[i].total);
                  }
                  delete tmpData[i].values;
                }
            }
            //  //console.log('Per tmpData >>> ' + JSON.stringify(tmpData));
            this.rawLoginActivityPer$Data.next(Object.assign([], result));
          } else {
            this.rawLoginActivityPer$Data.next(Object.assign([], EMPTY));
          }
        });

      } else {
        this.rawLoginActivityPer$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // user tab
  getUserActivityTrendData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    this.userUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (let key in filter) {
                if(key!='role'){
                  if (item[key] === undefined || item[key] != filter[key]) {                 
                    return false;
                  }         
                }else{
                  // //console.log('Role is being filtered');
                  if(JSON.stringify(item.role) !== JSON.stringify(filter.role) ){
                    return false;
                  }
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .key(function(d: any) { return d.activity_date; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_logins); });
              })
              .entries(filterredData);
            // //console.log('trend data >>> ' + JSON.stringify(tmpData));
            let i;
            const result: any[] = [];
            for (i = 0; i < tmpData.length; i++){
                result[i] = {};
                result[i].id = tmpData[i].key + 's';
                // tmpData[i].count = tmpData[i]['value'];
                // delete tmpData[i].key;
                // delete tmpData[i].value;
                if (tmpData[i].values) {
                  let j = 0;
                  result[i].values = [];
                  for (j = 0; j < tmpData[i].values.length; j ++) {
                    let from = tmpData[i].values[j].key.split('-');
                    // var f = new Date(from[2], from[1] - 1, from[0])
                    let mydate = new Date(from[2], from[1] - 1, from[0], 0, 0, 0, 0);
                    result[i].values.push({
                      date: mydate,
                      count: tmpData[i].values[j].value
                    });
                  }
                  result[i].values.sort((a, b) => a.date.getTime() - b.date.getTime());
                  // delete tmpData[i].values;
                }
            }
            // //console.log('Per trend data >>> ' + JSON.stringify(result));
            this.rawUserTrend$Data.next(Object.assign([], result));
          } else {
            this.rawUserTrend$Data.next(Object.assign([], EMPTY));
          }
        });

      } else {
        this.rawUserTrend$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and user tab user activity overview chart data
  getTotalUsersData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */

    this.userUsage$Data.subscribe( data => {
      // //console.log('data ########### ' + data);
      if (data && data.length > 0) {
        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {
          if (filter) {
            filterredData = data.filter(function(item){
              for (let key in filter) {
                if(key!='role'){
                  if (item[key] === undefined || item[key] != filter[key]) {                 
                    return false;
                  }         
                }else{
                 // //console.log('Role is being filtered');
                  if(JSON.stringify(item.role) !== JSON.stringify(filter.role) ){
                    return false;
                  }
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_total_registered_users); });
              })
              .entries(filterredData);
            // //console.log('tmpData >>> ' + JSON.stringify(tmpData));
            let i;
            const result: any[] = [];
            for (i = 0; i < tmpData.length; i++){
                result[i] = {};
                result[i].id = tmpData[i].key;
                result[i].count = tmpData[i].value;
            }
            this.rawTotalUsers$Data.next(Object.assign([], result));
          } else {
            this.rawTotalUsers$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawTotalUsers$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and user tab
  getTotalUsersPerData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    this.userUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (let key in filter) {
                if(key!='role'){
                  if (item[key] === undefined || item[key] != filter[key]) {                 
                    return false;
                  }         
                }else{
                  ////console.log('Role is being filtered');
                  if(JSON.stringify(item.role) !== JSON.stringify(filter.role) ){
                    return false;
                  }
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData1 = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_total_registered_users); });
              })
              .entries(filterredData);

            const tmpData2 = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_active_users); });
              })
              .entries(filterredData);
            // //console.log('Per tmpData >>> ' + JSON.stringify(tmpData));
            let i;
            const result: any[] = [];
            for (i = 0; i < tmpData1.length; i++){
                result[i] = {};
                result[i].role = tmpData1[i].key;

                let j = 0;
                for (j = 0; j < tmpData2.length; j ++) {
                  if (tmpData1[i].key === tmpData2[j].key) {
                    result[i].registered = tmpData1[i].value;
                    if (tmpData1[i].value && tmpData1[i].value > 0) {
                      result[i]['active'] = Math.round((tmpData2[j].value  / tmpData1[i].value)*100);
                    }
                    else {
                      result[i]['active'] = 0;
                    }
                  }
                }
            }
            ////console.log('jjjjjj total Users >>> ' + JSON.stringify(result));
            this.rawTotalUsersPer$Data.next(Object.assign([], result));
          } else {
            this.rawTotalUsersPer$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawTotalUsersPer$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and user tab user activity overview chart data
  getNewUsersData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */

    this.userUsage$Data.subscribe( data => {
      // //console.log('data ########### ' + data);
      if (data && data.length > 0) {
        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (let key in filter) {
                if(key!='role'){
                  if (item[key] === undefined || item[key] != filter[key]) {                 
                    return false;
                  }         
                }else{
                 // //console.log('Role is being filtered');
                  if(JSON.stringify(item.role) !== JSON.stringify(filter.role) ){
                    return false;
                  }
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_new_registered_user); });
              })
              .entries(filterredData);
            // //console.log('tmpData >>> ' + JSON.stringify(tmpData));
            let i;
            const result: any[] = [];
            for (i = 0; i < tmpData.length; i++){
                result[i] = {};
                result[i].id = tmpData[i].key;
                result[i].count = tmpData[i].value;
            }

           // //console.log('New Users >>> ' + JSON.stringify(result));
            this.rawNewUsers$Data.next(Object.assign([], result));
          } else {
            this.rawNewUsers$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawNewUsers$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and user tab
  getNewUsersPerData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    this.userUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (let key in filter) {
                if(key!='role'){
                  if (item[key] === undefined || item[key] != filter[key]) {                 
                    return false;
                  }         
                }else{
                  // //console.log('Role is being filtered');
                  if(JSON.stringify(item.role) !== JSON.stringify(filter.role) ){
                    return false;
                  }
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData1 = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_new_registered_user); });
              })
              .entries(filterredData);

            const tmpData2 = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_new_registered_active_users); });
              })
              .entries(filterredData);
           //console.log('Per tmpData1 >>> ' + JSON.stringify(tmpData1));
            //console.log('Per tmpData2 >>> ' + JSON.stringify(tmpData2));

            let i;
            const result: any[] = [];
            for (i = 0; i < tmpData1.length; i++){
                result[i] = {};
                result[i].role = tmpData1[i].key;

                let j = 0;
                for (j = 0; j < tmpData2.length; j ++) {
                  if (tmpData1[i].key === tmpData2[j].key) {
                    result[i].registered = tmpData1[i].value;
                    if (tmpData1[i].value && tmpData1[i].value > 0) {
                      result[i]['active'] = Math.round((tmpData2[j].value  / tmpData1[i].value)*100);
                    }
                    else {
                    result[i]['active'] = 0;
                    }
                  }
                }
            }
             //console.log('Janaki New Users result >>> ' + JSON.stringify(result));
            this.rawNewUsersPer$Data.next(Object.assign([], result));
          } else {
            this.rawNewUsersPer$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawNewUsersPer$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // filter list for user type/role and gender
  listGender() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    this.userUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (let key in filter) {
                if(key!='role'){
                  if (item[key] === undefined || item[key] != filter[key]) {                 
                    return false;
                  }         
                }else{
                  // //console.log('Role is being filtered');
                  if(JSON.stringify(item.role) !== JSON.stringify(filter.role) ){
                    return false;
                  }
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.gender_id; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_total_registered_users); });
              })
              .entries(filterredData);

            let i;
            const result: any[] = [];
            for (i = 0; i < tmpData.length; i++){
                result[i] = {};
                result[i].gender = tmpData[i].key;
                result[i].count = tmpData[i].value;
            }
          //  //console.log('total Genders >>> ' + JSON.stringify(tmpData));
            this.rawGenderList$Data.next(Object.assign([], result));
          } else {
            this.rawGenderList$Data.next(Object.assign([], EMPTY));
          }
        });

      } else {
        this.rawGenderList$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  listUserType() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    this.userUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (let key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                } if(key!='role'){
                  if (item[key] === undefined || item[key] != filter[key]) {                 
                    return false;
                  }         
                }else{
                  // //console.log('Role is being filtered');
                  if(JSON.stringify(item.role) !== JSON.stringify(filter.role) ){
                    return false;
                  }
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mUserUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_total_registered_users); });
              })
              .entries(filterredData);

            let i;
            const result: any[] = [];
            for (i = 0; i < tmpData.length; i++){
                result[i] = {};
                result[i].role = tmpData[i].key;
                result[i].count = tmpData[i].value;
            }
            //  //console.log('total Users >>> ' + JSON.stringify(result));
            this.rawUserType$Data.next(Object.assign([], result));
          } else {
            this.rawUserType$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawUserType$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // end
}
